import { render, staticRenderFns } from "./OfficesLoader.vue?vue&type=template&id=1fda8efe&"
import script from "./OfficesLoader.vue?vue&type=script&lang=js&"
export * from "./OfficesLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports